import React from 'react'
import mahfuz from '../../Assests/mahfuz2.JPG'
import './Banner.css'
import Typewriter from 'typewriter-effect';
export default function Banner() {
    return (
        <div>
            <div className='img-gradient relative'>

                <img src={mahfuz} alt="" className='w-full' />
                {/* <img src={man} alt="" className='w-full' /> */}

                <div className='flex justify-center md:justify-start'>
                    <h1 className=' text-white w-1/2  top-1/4 text-center text-md sm:text-lg md:mx-12 md:top-1/4 md:left-36 md:w-1/3 font-bold z-10 absolute  md:text-start  text-base  md:text-2xl lg:text-4xl xl:text-5xl'>I'M <span className=' text-red-500'>ABDULLAH AL MAHFUZ</span></h1>
                </div>
                <div className='flex justify-center md:justify-start'>
                    <div className=' text-green-500 z-10 top-[20%] sm:top-[25%] mt-16 sm:mt-8 md:mx-12 md:text-[20px] text-center md:text-start md:w-[40%] md:top-1/4 md:left-36 md:mt-16 lg:top-1/3 lg:mt-12 xl:top-1/3   xl:mt-12 absolute opacity-80 font-bold'>
                        <Typewriter
                            options={{
                                strings: ['WEB DEVELOPER', 'MERN STACK DEVELOPER', 'REACT.JS DEVELOPER', "FRONTEND DEVELOPER"],
                                autoStart: true,
                                loop: true,
                                pauseFor: 500
                            }}
                        />
                    </div>
                </div>
                <div className='flex justify-center md:justify-start'>
                    <div className='flex absolute text-white  shadow-lg rounded-lg top-[63%] sm:top-[50%] text-center md:mx-12 md:top-[48%] font-bold z-10  md:left-36 md:text-start text-md'>
                        <div className=' flex justify-center md:justify-start'>
                            <div className=''>
                                <a target='_blank' href='https://drive.google.com/uc?id=14mnZ34uSc0QN8OsloSCQJvIICI34kXRq&export=download'
                                    className=' text-white border hover:text-green-500 border-r-green-500   rounded-lg p-2 md:p-3  text-center font-bold z-10 text-xs md:text-base uppercase  shadow-md shadow-red-500'>Download <span className=' '>Resume</span></a>
                                <a href='#contact-me' className=' text-white border hover:text-green-500 border-l-green-500 rounded-lg p-2 md:p-3 ml-4   text-center  font-bold z-10 text-xs  md:text-base shadow-md shadow-red-500 uppercase '><span className=' '>Contact</span> Me</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}
